// Actions
export class SelectLocale {
  static readonly type = '[I18n] SelectLocale';

  constructor(public locale: string) {
  }
}

